import { Link } from 'react-router-dom';

export default function ContainerPricing() {
  const plans = [
    {
      name: '开发版',
      price: '免费',
      period: '',
      description: '适合个人开发者和小型项目',
      features: [
        '每月 1000 次 API 调用',
        '单个文件最大 10MB',
        '基础 PDF 处理功能',
        '社区技术支持',
        '标准 API 文档'
      ],
      cta: '免费试用',
      popular: false
    },
    {
      name: '专业版',
      price: '¥2,999',
      period: '/月',
      description: '适合中小型企业和团队',
      features: [
        '每月 50,000 次 API 调用',
        '单个文件最大 50MB',
        '完整 PDF 处理功能',
        '优先技术支持',
        '自定义部署方案',
        '性能监控面板'
      ],
      cta: '立即购买',
      popular: true
    },
    {
      name: '企业版',
      price: '定制',
      period: '',
      description: '适合大型企业和高并发场景',
      features: [
        '无限 API 调用',
        '无文件大小限制',
        '全部高级功能',
        '7×24 专属支持',
        '私有化部署',
        '定制开发服务',
        'SLA 服务保障'
      ],
      cta: '联系销售',
      popular: false
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            灵活的定价方案
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            选择适合您业务需求的方案，随时升级或降级
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div 
              key={index}
              className={`rounded-2xl p-8 transition-all duration-300 hover:-translate-y-2 ${
                plan.popular 
                  ? 'bg-gradient-to-br from-teal-600 to-cyan-600 text-white shadow-2xl scale-105' 
                  : 'bg-white border border-gray-200 shadow-lg hover:shadow-2xl'
              }`}
            >
              {plan.popular && (
                <div className="inline-block px-4 py-1 bg-white/20 backdrop-blur-sm rounded-full text-sm font-semibold mb-4">
                  最受欢迎
                </div>
              )}
              
              <h3 className={`text-2xl font-bold mb-2 ${plan.popular ? 'text-white' : 'text-gray-900'}`}>
                {plan.name}
              </h3>
              
              <div className="mb-4">
                <span className={`text-5xl font-bold ${plan.popular ? 'text-white' : 'text-gray-900'}`}>
                  {plan.price}
                </span>
                <span className={`text-lg ${plan.popular ? 'text-white/80' : 'text-gray-600'}`}>
                  {plan.period}
                </span>
              </div>
              
              <p className={`mb-6 ${plan.popular ? 'text-white/90' : 'text-gray-600'}`}>
                {plan.description}
              </p>
              
              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, idx) => (
                  <li key={idx} className="flex items-start">
                    <i className={`ri-check-line mr-2 mt-1 flex-shrink-0 w-5 h-5 flex items-center justify-center ${
                      plan.popular ? 'text-cyan-200' : 'text-teal-600'
                    }`}></i>
                    <span className={plan.popular ? 'text-white/90' : 'text-gray-600'}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>
              
              <Link
                to="/contact"
                className={`block w-full py-3 rounded-lg text-center font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  plan.popular
                    ? 'bg-white text-teal-600 hover:bg-gray-50'
                    : 'bg-gradient-to-r from-teal-600 to-cyan-600 text-white hover:from-teal-700 hover:to-cyan-700'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-4">
            需要更多信息？查看我们的
            <Link to="/contact" className="text-teal-600 hover:text-teal-700 font-semibold mx-1 cursor-pointer">
              完整定价说明
            </Link>
            或
            <Link to="/contact" className="text-teal-600 hover:text-teal-700 font-semibold mx-1 cursor-pointer">
              联系销售团队
            </Link>
          </p>
        </div>
      </div>
    </section>
  );
}
